import {
  paymentLinkProviderAtom,
  paymentOptionsAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { useAtomValue } from 'jotai'

type PaymentProvider = 'STRIPE' | 'GOCARDLESS' | 'NONE'

export const resolvePaymentProvider = (
  paymentOptions: Array<string>,
  paymentLinkProvider?: 'STRIPE' | 'GOCARDLESS'
): PaymentProvider => {
  if (!paymentOptions.includes('LINK')) return 'NONE'

  /**
   * There was a migration to backfill older invoices with `paymentLinkProvider: 'STRIPE'` if they also had
   * `paymentOptions: ['LINK']`, but assume the provider was STRIPE if `paymentLinkProvider` is undefined
   * Source: https://sequenceslack.slack.com/archives/C02TPFRHWTV/p1775746034376209
   */
  if (!paymentLinkProvider) {
    return 'STRIPE'
  }

  return paymentLinkProvider
}

export const usePaymentProviderForInvoice = (): PaymentProvider => {
  const paymentOptions = useAtomValue(paymentOptionsAtom)
  const paymentLinkProvider = useAtomValue(paymentLinkProviderAtom)

  return resolvePaymentProvider(paymentOptions, paymentLinkProvider)
}
